module.exports = __webpack_public_path__ + "img/undraw_finish_line.f363720e.svg";